const times = (count, callback) => {
  const collections = []

  for (let j = 0; j < count; j += 1) {
    collections.push(callback(j))
  }

  return collections
}

export default times
